import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ENVIRONMENT_TOKEN, RedirectionService, StateService, TranslationService, WcagService } from '@lib/core';

@Component({
  template: ''
})
export class AppComponent implements OnInit {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) protected environment: any,
    protected router: Router,
    protected translationService: TranslationService,
    protected redirectionService: RedirectionService,
    protected stateService: StateService
  ) {
    this.makeRedirectionOnAppLaunch();
  }

  public ngOnInit(): void {
    this.handleHashUrlRedirect();
  }

  useLanguage(locale: string) {
    this.translationService.useLanguage(locale);
  }

  protected makeRedirectionOnAppLaunch(): void {
    let urlToRedirect: string | null = this.redirectionService.getRedirectionOnNextAppLaunch();
    this.redirectionService.removeRedirectionOnNextAppLaunch();
    if (!urlToRedirect) {
      return;
    }

    const queryParameters: URLSearchParams = new URLSearchParams(window.location.search);
    const urlParameters: string = queryParameters.toString();

    if (urlParameters && urlParameters.length > 0) {
      urlToRedirect = urlToRedirect + '&' + urlParameters;
    }

    window.location.href = urlToRedirect;
  }

  private handleHashUrlRedirect(): void {
    const hash = window.location.hash;
    if (!hash || !hash.startsWith('#/')) {
      return;
    }

    const pathWithQuery = hash.substring(1); // np. /order/summary?x=1
    const [rawPath, rawQuery = ''] = pathWithQuery.split('?');

    const availableLangs: string[] = this.environment?.constants?.language?.available ?? [];
    const defaultLang: string = this.environment?.constants?.language?.default ?? 'pl';
    const currentLang = this.stateService.getItem('lang') || this.translationService.currentLang || defaultLang;

    const hasLangPrefix = availableLangs.some((lang) => rawPath === `/${lang}` || rawPath.startsWith(`/${lang}/`));
    const finalPath = hasLangPrefix ? rawPath : `/${currentLang}${rawPath}`;
    const finalUrl = rawQuery ? `${finalPath}?${rawQuery}` : finalPath;

    this.router.navigateByUrl(finalUrl, { replaceUrl: true });
  }
}
